import { useState } from "react";
import { Segmented } from "../ui";

interface Props {
  from: string;
  to: string;
  onApply: (from: string, to: string) => void;
  loading?: boolean;
}

function daysAgo(n: number): string {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().split("T")[0];
}

const PRESETS: Array<{ id: number; label: string }> = [
  { id: 6, label: "7d" },
  { id: 29, label: "30d" },
  { id: 89, label: "90d" },
];

export default function ReportsDateFilter({ from, to, onApply, loading }: Props) {
  const [draftFrom, setDraftFrom] = useState(from);
  const [draftTo, setDraftTo] = useState(to);

  const applyPreset = (days: number) => {
    if (loading) return;
    const newFrom = daysAgo(days);
    const newTo = daysAgo(0);
    setDraftFrom(newFrom);
    setDraftTo(newTo);
    onApply(newFrom, newTo);
  };

  const activePreset =
    PRESETS.find((p) => draftFrom === daysAgo(p.id) && draftTo === daysAgo(0))?.id ?? null;

  return (
    <div className="sq-toolbar is-plain reports-filter">
      <Segmented
        label="Date range"
        value={activePreset}
        onChange={applyPreset}
        options={PRESETS}
      />
      <label className="sq-field is-half">
        <span>From</span>
        <input
          type="date"
          className="sq-input"
          value={draftFrom}
          max={draftTo}
          onChange={(e) => setDraftFrom(e.target.value)}
        />
      </label>
      <label className="sq-field is-half">
        <span>To</span>
        <input
          type="date"
          className="sq-input"
          value={draftTo}
          min={draftFrom}
          max={daysAgo(0)}
          onChange={(e) => setDraftTo(e.target.value)}
        />
      </label>
      <button
        type="button"
        className="btn btn-sm btn-outline-secondary"
        onClick={() => onApply(draftFrom, draftTo)}
        disabled={loading}
      >
        Apply
      </button>
    </div>
  );
}
